import { HomeDisplayWithProduct } from 'src/admin-entity/interface/product/product-home-display-with-product.interface';
import { ProductOld } from 'src/admin-entity/interface/product/product-old.interface';
import { ProductOptionGroup } from 'src/admin-entity/interface/product/product-option-group.interface';
import { configByPlatform } from 'src/config/platform';
import { TaxStatus } from 'src/admin-entity/enum/payment/tax-status.enum';

export interface ProductSliceInitType {
    product: ProductOld;
    selectedComb: any;
    simpleProductId: number;
    removedProductOptionGroupWithShipmentDate: ProductOptionGroup;
    originHomeDisplayWithProduct: HomeDisplayWithProduct[];
    representImageFiles?: string[];
    savedProductType: number;
}

export const initialState: ProductSliceInitType = {
    simpleProductId: 0,
    selectedComb: null,
    product: {
        id: 0,
        name: '',
        productType: 1,
        productFunding: {
            createDate: Date(),
            id: 0,
            salesQuantity: 0,
            targetQuantity: 0,
            totalSaleAmount: 0,
            updateDate: Date(),
            successRate: '0%',
        },
        salesQuantity: 0,
        contents: '',
        representImageBucketUrl: '',
        representImageFile: '',
        thumbnailBucketUrl: '',
        unstoringDaysAfter: 0,
        scoreAverage: 0,
        freeShippingFeeConditionPrice: 0,
        deeplink: '',
        isExclusive: false,
        restrictedStockOrder: 0,
        productStatus: 'stock_in',
        summaryTitle: '',
        productTagGroup: [],
        productShippingFee: {
            shippingFee: 3000,
            primaryAreaShippingFee: 3000,
            secondaryAreaShippingFee: 5500,
            thirdAreaShippingFee: 7500,
        },
        productPrice: {
            price: 0,
            listPrice: 0,
            supplyPrice: 0,
            specialSalePrice: 0,
        },
        productOrderConditions: [],
        productSaleType: {
            commingSoonDate: new Date().toISOString(),
            isCommingSoon: false,
            limitedPeriodSaleBeginDate: new Date().toISOString(),
            limitedPeriodSaleEndDate: new Date().toISOString(),
            noResale: false,
            saleType: 'INDEFINITE_SALE',
            // roundingUnit: 1,
            isSpecialSaleDate: false,
            postSpecialSale: 1,
            specialSaleDate: new Date().toISOString(),
            // specialSaleRate: 0,
            isSpecialSale: false,
        },
        productImageRepresent: [],
        productDetail: {
            adminMemo: '',
            optionIdPath: null,
            productImages: [],
            productOptionCombinations: [],
            productOptionGroups: [{ name: '', productOptions: [{ name: '' }] }],
            propertyJson: configByPlatform.propertyJson,
            propertyJsonString: '',
            shippingFeeUnit: 0,
            taxStatus: TaxStatus.TAXABLE,
            videoUrl: '',
        },
        category: { id: 0 },
        tags: [],
        deliveryCompany: { id: 1, name: 'CJ대한통운' },
        distributor: configByPlatform.distributor,
        unstoringDateFromToday: new Date().toISOString(),
        categories: [],
        // _productConditions?: ProductConditions,
        userProductOrderConditions: [],
        // _isFavorites?: FavoriteUserProduct,
        // _share?: ShareUserProduct,

        isFreeShippingFee: true,
        restStocks: 0,
        isBundleByDistributor: true,
        bundleShippingFeeType: 0, // 0: default, 1: 업체별 합배송, 2: 옵션별 합배송
        maxUnitInBox: 0,
        labelRecommend: 'BEST',
        labelShippingMethod: 'CUMA_SHIPPING',
        // giftExpireType: 'AFTER_DAYS',
        // giftFixedExpireDate: new Date().toISOString(),
        giftExpireDays: 5,
        isVisibleInList: true,
        useGift: true,
        shipmentDateOptionType: 1, // 1: 일반, 2: 지정일 출고, 3: 순차 출고
        shipmentDateOption: '0|7',
        minAppUserGrade: 0,
        homeDisplayWithProduct: [],
        productExtra: {
            useKakaosync: false,
            imageOriginPath: '',
        },
        productRelated: {
            productRelatedType: 'displayCategoryUse',
            displayCategory: null,
            // 이 부분 추후에 수정해야함 일단 db에 없어서 null!
        },
        productRelatedProducts: [],
        isAppOnly: false,
        isUndeliverableSecondaryarea: false,
        isUndeliverableThirdarea: false,
        isInternationalShipping: true,
        isRepurchasable: true,
        minPurchaseQty: 0,
        maxPurchaseQty: 0,
        // tossVariantKey: PLATFORM === 'jikgu' ? 'jikgu' : 'DEFAULT',
        tossVariantKey: null,
    },
    removedProductOptionGroupWithShipmentDate: undefined,
    originHomeDisplayWithProduct: [],
    representImageFiles: [],
    savedProductType: 1,
};
